import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ocrSpace = defineConnector({
  identifier: "ocrSpace",
  name: "OCR.space",
  tagLine: "OCR and PDF text extraction",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.ocr\\.space/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Register for an API key at [OCR.space](https://ocr.space/OCRAPI). Free and paid plans use the same header-based authentication pattern.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "OCR.space API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.ocr.space/parse/imageurl?url=https://dl.a9t9.com/ocr/solarcell.jpg",
  },
});
